import React from 'react'
import { ThemeProvider, createTheme } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Link from '@material-ui/core/Link'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import LaunchOutlinedIcon from '@material-ui/icons/LaunchOutlined'
import CircularHighlightedIcon from 'components/circular-highlighted-icon'
import themes from 'themes'
import { showNewMessage } from 'lib/support'
import { authenticatedRedirectLink } from 'lib/pga-dot-coach'

const IneligibleUserPage = () => {
  return (
    <ThemeProvider theme={createTheme(themes.pgaCoach)}>
      <Container maxWidth="sm">
        <Box my={4}>
          <Paper elevation={4}>
            <Box
              p={4}
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <Box mb={2}>
                <CircularHighlightedIcon icon={ReportProblemOutlinedIcon} />
              </Box>
              <Box mb={2}>
                <Typography variant="body1" align="center" gutterBottom>
                  You are currently not eligible to use PGA Coach. Please
                  contact support for further assistance.
                </Typography>
                <Typography variant="body1" align="center">
                  For coach training and educational resources, visit the{' '}
                  <Link href={authenticatedRedirectLink('/trainingCenter')}>
                    <strong>
                      Training Center
                      <LaunchOutlinedIcon fontSize="inherit" />
                    </strong>
                  </Link>
                  .
                </Typography>
              </Box>
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  showNewMessage(
                    "I don't have access to use PGA Coach. Please help me gain access to use this service.",
                  )
                }}
              >
                Contact Support
              </Button>
            </Box>
          </Paper>
        </Box>
      </Container>
    </ThemeProvider>
  )
}

export default IneligibleUserPage
